const DEFAULT_LIMIT = 50;

const INITIAL_INSTANCE_NAVIGATION_STATE = {
  currentSearchParams: {},
  count: 0,
  limit: DEFAULT_LIMIT,
  listContext: {},
  offset: 0,
  pageIds: [],
  statusContext: "all",
  updatedAt: 0,
};

const toNumber = (value, fallback = 0) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : fallback;
};

const getPageIds = (edges = []) =>
  edges
    .map(edge => {
      const rawId = edge?.id;
      if (rawId === null || rawId === undefined || rawId === "") {
        return NaN;
      }
      return toNumber(rawId, NaN);
    })
    .filter(Number.isFinite);

const buildInstanceNavigationSnapshot = ({
  count = 0,
  edges = [],
  listContext = {},
  queryVariables = {},
  statusContext = "all",
} = {}) => {
  const limit = toNumber(queryVariables?.limit, DEFAULT_LIMIT) || DEFAULT_LIMIT;
  const offset = toNumber(queryVariables?.offset, 0);
  const currentSearchParams = {
    ...queryVariables,
    limit,
  };

  delete currentSearchParams.offset;

  return {
    currentSearchParams,
    count: toNumber(count, 0),
    limit,
    listContext,
    offset,
    pageIds: getPageIds(edges),
    statusContext,
    updatedAt: Date.now(),
  };
};

const getInstanceNavigationState = ({ instanceId, snapshot } = {}) => {
  if (!snapshot || typeof instanceId !== "number") {
    return {
      hasNext: false,
      hasPrevious: false,
      nextId: null,
      nextOffset: null,
      previousId: null,
      previousOffset: null,
    };
  }

  const { count = 0, limit = DEFAULT_LIMIT, offset = 0, pageIds = [] } = snapshot;
  const indexOnPage = pageIds.findIndex(id => id === instanceId);

  if (indexOnPage < 0) {
    return {
      hasNext: false,
      hasPrevious: false,
      nextId: null,
      nextOffset: null,
      previousId: null,
      previousOffset: null,
    };
  }

  const globalIndex = offset + indexOnPage;
  const hasPrevious = globalIndex > 0;
  const hasNext = globalIndex < count - 1;
  const previousId = indexOnPage > 0 ? pageIds[indexOnPage - 1] : null;
  const nextId =
    indexOnPage < pageIds.length - 1 ? pageIds[indexOnPage + 1] : null;
  const previousOffset = hasPrevious && !previousId ? Math.max(offset - limit, 0) : null;
  const nextOffset = hasNext && !nextId ? offset + limit : null;

  return {
    hasNext,
    hasPrevious,
    nextId,
    nextOffset,
    previousId,
    previousOffset,
  };
};

export {
  DEFAULT_LIMIT,
  INITIAL_INSTANCE_NAVIGATION_STATE,
  buildInstanceNavigationSnapshot,
  getInstanceNavigationState,
};
